import { isNullOrEmpty } from "@smpu-web/utils/utils";
import React from "react";

export const getQueryStringWithParam = (param: string) => {
    let search = window.location.search;
    let params = new URLSearchParams(search);

    return params.get(param)
}

export const isMimCall = () => {
    return !isNullOrEmpty(getQueryStringWithParam("mim")) && !isNullOrEmpty(getQueryStringWithParam("ts"))
}

export const setSelectedPosType = (posType: string) => {
    switch (posType) {
        case "1":
            return "MASAUSTU";

        case "2":
            return "YAZARKASA";

        case "3":
            return "MOBIL";

        case "4":
            return "MPOS";
            
        default:
            return null;
    }
}

const hasValue = (value) => {
    if (!value || value === 0 || value === "0") {
        return false;
    } else {
        return true;
    }
};

export const validateInput = (minValue: number, maxValue: number, errorMessage: string) => {
    return (value) => {
        if (hasValue(value)) {
            if (value.toString().startsWith('0') || value > maxValue || value < minValue) {
                return React.createElement(
                    "div",
                    { className: "bapp-message" },
                    errorMessage
                );
            }
        } else {
            return React.createElement(
                "div",
                { className: "bapp-message" },
                errorMessage
            );
        }
    };
}
